import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "circle-check",
  "use": "circle-check-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"circle-check\"><path d=\"M11 1.486c-5.246 0-9.514 4.268-9.514 9.514 0 5.246 4.268 9.514 9.514 9.514 5.246 0 9.514-4.268 9.514-9.514 0-5.246-4.268-9.514-9.514-9.514M11 22C4.935 22 0 17.065 0 11 0 4.934 4.935 0 11 0c6.066 0 11 4.934 11 11 0 6.065-4.934 11-11 11\" /><path d=\"M15.9 7l-6.233 6.234L7.1 10.667l-1.1 1.1 3.667 3.666L17 8.1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/circle-check.svg
// module id = 1728
// module chunks = 0